export function getNextTick(now: number, updateEveryN: number, minTickDelay = 0): number {
  const nextTick = updateEveryN - (now % updateEveryN);
  return Math.max(nextTick, minTickDelay);
}
